import gql from 'graphql-tag';
import UserSegment from './user_segment';

export default gql`
  fragment LeaderboardConfig on LeaderboardConfig {
    id
    title
    description
    leaderboard_status
    created_at
    start_at
    end_at
    all_users
    segment_ids
    segments {
      ...UserSegment
    }
  }
  ${UserSegment}
`;
